import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';

@Component({
  selector: 'ods-loader',
  imports: [IonicModule],
  templateUrl: './ods-loader.component.html',
  styleUrl: './ods-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class OdsLoaderComponent {
}
